// @figma file=tbd node=tbd name="ButtonGroup" set="tbd" verified=tbd

import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '../../lib/utils';

export const buttonGroupVariants = cva('inline-flex', {
  variants: {
    orientation: {
      horizontal: 'flex-row',
      vertical: 'flex-col',
    },
    size: {
      sm: '[&>button]:h-8 [&>button]:px-3 [&>button]:text-xs',
      default: '[&>button]:h-9 [&>button]:px-4 [&>button]:text-sm',
      lg: '[&>button]:h-10 [&>button]:px-8 [&>button]:text-base',
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
    size: 'default',
  },
});

export interface ButtonGroupProps
  extends React.HTMLAttributes<HTMLFieldSetElement>,
    VariantProps<typeof buttonGroupVariants> {
  attached?: boolean;
  disabled?: boolean;
}

const ButtonGroup = React.forwardRef<HTMLFieldSetElement, ButtonGroupProps>(
  (
    { className, orientation, size, attached = true, disabled = false, children, ...props },
    ref,
  ) => {
    const attachedClasses =
      attached && orientation !== 'vertical'
        ? '[&>button:not(:first-child)]:rounded-l-none [&>button:not(:last-child)]:rounded-r-none [&>button:not(:first-child)]:-ml-px'
        : attached && orientation === 'vertical'
          ? '[&>button:not(:first-child)]:rounded-t-none [&>button:not(:last-child)]:rounded-b-none [&>button:not(:first-child)]:-mt-px'
          : 'gap-1';

    return (
      <fieldset
        ref={ref}
        disabled={disabled}
        data-disabled={disabled || undefined}
        className={cn(
          'border-0 p-0 m-0',
          buttonGroupVariants({ orientation, size }),
          attachedClasses,
          disabled && 'opacity-50 pointer-events-none',
          className,
        )}
        {...props}
      >
        {children}
      </fieldset>
    );
  },
);
ButtonGroup.displayName = 'ButtonGroup';

export { ButtonGroup };
